import $connector from "./apis/connector";
import { $service } from "@/services/apis";

/**
 * handleConnectorApp
 * @description Handles connector app requests
 * @returns {Promise}
 */
export const handleConnectorApp = (params = {}) => {
  return $connector.get("connection/shopify/callback", { params });
};

export const createNetoConnection = (type, config, headers) => {
  return $connector.post(`/connection/${type}.json`, config, headers);
};

export const createNetoIntegration = (config) => {
  return $service.post(`/connection/neto/install`, config, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
